import React, { FC } from 'react';
import styled from 'styled-components';
import { FinancialStat } from '../types';
import { GaugeChartValue, StatLabelWrapper } from './common';

const MiniCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 200px;
  gap: var(--spacing-05);
  padding: var(--spacing-05);
  background-color: var(--white-100);
  box-shadow: var(--shadow-02);
`;

interface Props {
  stat: FinancialStat;
}

export const FinancialsMiniCard: FC<Props> = ({ stat: { label, value } }) => {
  return (
    <MiniCardWrapper>
      <StatLabelWrapper>{label}</StatLabelWrapper>
      <GaugeChartValue>{value}</GaugeChartValue>
    </MiniCardWrapper>
  );
};
